import { Component, OnInit } from '@angular/core';
import { LandaService } from 'src/app/core/services/landa.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

/**
 * Footer component
 */
export class FooterComponent implements OnInit {
  
  detailproject: any;
  // set the currenr year
  year: number = new Date().getFullYear();

  // ==== Floating help / support ====
  showHelpMenu = false;
  helpLinks = {
    manualBook: 'https://docs.humanis.id',
    tos: 'https://docs.humanis.id/sla',
    contact: 'https://api.whatsapp.com/send?phone=+628981000088&text=Halo+Humanis+Team+Support%2C+Saya+butuh+bantuan',
  };

  constructor(
    public landaService: LandaService) { }

  ngOnInit() {
    this.detailproject = this.landaService.getDetailProject();
  }

  /** Buka link help/support di tab baru lalu tutup menu. */
  openHelpLink(url: string) {
    window.open(url, '_blank', 'noopener');
    this.showHelpMenu = false;
  }

}
